module.exports = __webpack_public_path__ + "img/education-menu-cafeteria.6cb1e693.png";